import { AccommodationBooking } from './accommodation-booking.model';

export class AccommodationPulpoBooking extends AccommodationBooking {
  destinationId: number;
  cityId: number;
}
